export const INIT_NOTIFICATIONS = 'INIT_NOTIFICATIONS',
      SUBSCRIBE_PUSH_CLIENT_REQUEST = 'SUBSCRIBE_PUSH_CLIENT_REQUEST',
      UNSUBSCRIBE_PUSH_CLIENT = 'UNSUBSCRIBE_PUSH_CLIENT',
      SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
